"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavDropdown = void 0;

var _react = _interopRequireDefault(require("react"));

var _molecules = require("../../molecules");

var _DashboardPanel = require("../DashboardPanel");

var _ = require("../..");

var _GamesList = require("../GamesList");

require("./NavDropdown.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Drew Burnett
 */
// Imports
// Nav Dropdown
var NavDropdown = function NavDropdown(_ref) {
  var user = _ref.user,
      allTeams = _ref.allTeams,
      divisions = _ref.divisions,
      recentGames = _ref.recentGames,
      shouldShowDivisionsSeparately = _ref.shouldShowDivisionsSeparately,
      traceIdURL = _ref.traceIdURL,
      offsetAxisX = _ref.offsetAxisX,
      offsetAxisY = _ref.offsetAxisY,
      maxHeight = _ref.maxHeight;
  var userId = user ? user.user_id : null;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.DropdownMenu, {
    title: "Nav",
    menuPortal: "#modal-root",
    className: "NavDropdown",
    classNameMenu: "dropdown",
    menuDirection: "bottom",
    offsetAxisX: offsetAxisX,
    offsetAxisY: offsetAxisY,
    buttonWidth: "auto",
    button: /*#__PURE__*/_react.default.createElement(_molecules.RoundButton, {
      trkAction: "Hamburger Pressed",
      borderColor: "transparent-color",
      iconColor: "grey3-color",
      iconSize: 24,
      icon: _.Icon.Type.Menu
    })
  }, /*#__PURE__*/_react.default.createElement(_.Column, {
    className: "navdropdown-inner-content",
    style: {
      maxHeight: maxHeight
    }
  }, /*#__PURE__*/_react.default.createElement(_DashboardPanel.DashboardPanel, {
    classNames: "explore",
    title: "Explore"
  }, /*#__PURE__*/_react.default.createElement(_molecules.DashboardPanelLink, {
    trkAction: "My Trace iD Pressed",
    icon: _.Icon.Type.Moment,
    to: "".concat(traceIdURL, "/find/user/").concat(userId),
    title: "My Trace iD"
  }), !shouldShowDivisionsSeparately && (allTeams === null || allTeams === void 0 ? void 0 : allTeams.slice(0, 3).map(function (team) {
    return /*#__PURE__*/_react.default.createElement(_molecules.DashboardPanelLink, {
      trkAction: "Team Link Pressed",
      key: "navdropdown-".concat(team.name),
      icon: _.Icon.Type.Soccer,
      to: "/".concat(team.name),
      title: team.title
    });
  })), /*#__PURE__*/_react.default.createElement(_molecules.DashboardPanelLink, {
    trkAction: "Leaderboard Pressed",
    icon: _.Icon.Type.Leaderboard,
    href: "/leader/boards/",
    title: "Leaderboards"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "divider"
  }), /*#__PURE__*/_react.default.createElement(_DashboardPanel.DashboardPanel, {
    title: "Recent games"
  }, /*#__PURE__*/_react.default.createElement(_GamesList.GamesList, {
    games: recentGames
  })), shouldShowDivisionsSeparately && divisions.map(function (division) {
    var _division$teams;

    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "divider"
    }), /*#__PURE__*/_react.default.createElement(_DashboardPanel.DashboardPanel, {
      key: "navdropdown-division-".concat(division.title),
      title: division.title,
      headerLinkTitle: "Settings",
      headerLink: "/#/".concat(division.teams[0].name, "/settings/division/").concat(division.division_id)
    }, (_division$teams = division.teams) === null || _division$teams === void 0 ? void 0 : _division$teams.map(function (team) {
      return /*#__PURE__*/_react.default.createElement(_molecules.DashboardPanelLink, {
        trkAction: "Team Link Pressed",
        key: "navdropdown-divisions-team-".concat(team.name),
        to: "/".concat(team.name),
        title: team.title
      });
    })));
  }))));
};

exports.NavDropdown = NavDropdown;
NavDropdown.defaultProps = {
  maxHeight: 'none'
};